export const TAG_NAME = 'risk/doc/upload_requirement';
